import { Spinner } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import InvoiceDetailsStore from '../../../stores/InvoiceDetailsStore';
import { ITranslateStore } from '../../../stores/TranslateStore';
import InfoNotice from '../notices/InfoNotice';
import WarningNotice from '../notices/WarningNotice';

import NoticeWithButton from '../../common/NoticeWithButton';
import InvoiceDetailsContentViewStore from '../../../stores/view/InvoiceDetailsContentViewStore';
import LayoutStore from '../../../stores/LayoutStore';
import InvoiceDetailsTable from './InvoiceDetailsTable';

interface IInvoiceDetailsContentProps {
  invoiceDetailsContentViewStore?: InvoiceDetailsContentViewStore;
  invoiceDetailsStore?: InvoiceDetailsStore;
  translateStore?: ITranslateStore;
  layoutStore?: LayoutStore;
}

@inject('invoiceDetailsContentViewStore', 'invoiceDetailsStore', 'translateStore', 'layoutStore')
@observer
export default class InvoiceDetailsContent extends React.Component<IInvoiceDetailsContentProps> {
  constructor(props: IInvoiceDetailsContentProps) {
    super(props);
    this.props.invoiceDetailsContentViewStore.setShowLargeInvoice(false);
  }

  public render(): JSX.Element {
    const invoiceDetails = this.props.invoiceDetailsStore.invoiceDetails;
    const { translate } = this.props.translateStore;

    if (invoiceDetails.isFinishedWithError) {
      return <WarningNotice translationKey="shared.invoice-details-modal.failed-to-load" />;
    }

    if (invoiceDetails.isInitialLoading) {
      return <Spinner />;
    }

    if (invoiceDetails.payload.status === 'ARCHIVED') {
      return <InfoNotice translationKey={'shared.invoice-details-modal.notices.archived'} />;
    }

    if (invoiceDetails.payload.status === 'TOO_LARGE' && !this.props.invoiceDetailsContentViewStore.showLargeInvoice) {
      return (
        <NoticeWithButton
          gaEvent="Link - load large invoice"
          noticeText={translate('shared.invoice-details-modal.notices.too-large')}
          buttonProps={{
            iconRight: '#arrow-right',
            text: translate('shared.invoice-details-modal.notices.too-large.button-label'),
            onClick: () => this.props.invoiceDetailsContentViewStore.setShowLargeInvoice(true)
          }}
        />
      );
    }

    if (invoiceDetails.payload.status === 'NOT_AVAILABLE') {
      return <InfoNotice translationKey={'shared.invoice-details-modal.notices.not-available'} />;
    }

    return this.props.invoiceDetailsContentViewStore.shouldShowInvoiceDetails() && <InvoiceDetailsTable />;
  }
}
